import React from 'react';

export default function LoggedOutAccountIcon(props: React.SVGAttributes<any>) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="8" fill="#AAAAAA" />
            <g opacity="0.24">
                <path fillRule="evenodd" clipRule="evenodd" d="M32 29.3335H24H32Z" fill="#F2F7FF" />
                <path fillRule="evenodd" clipRule="evenodd" d="M27.9988 33.3334L27.9997 25.3334L27.9988 33.3334Z" fill="#F2F7FF" />
                <path d="M25.3333 13.3334C25.3333 17.0153 22.3486 20.0001 18.6667 20.0001C14.9848 20.0001 12 17.0153 12 13.3334C12 9.65152 14.9848 6.66675 18.6667 6.66675C22.3486 6.66675 25.3333 9.65152 25.3333 13.3334Z" fill="#F2F7FF" />
                <path
                    d="M32 29.3335H24M27.9988 33.3334L27.9997 25.3334M8 33.3334V32.0001C8 28.3182 10.9848 25.3334 14.6667 25.3334H18.6667M25.3333 13.3334C25.3333 17.0153 22.3486 20.0001 18.6667 20.0001C14.9848 20.0001 12 17.0153 12 13.3334C12 9.65152 14.9848 6.66675 18.6667 6.66675C22.3486 6.66675 25.3333 9.65152 25.3333 13.3334Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path fillRule="evenodd" clipRule="evenodd" d="M32 29.3335H24H32Z" fill="#AAAAAA" />
            <path fillRule="evenodd" clipRule="evenodd" d="M27.9988 33.3334L27.9997 25.3334L27.9988 33.3334Z" fill="#AAAAAA" />
            <path d="M25.3333 13.3334C25.3333 17.0153 22.3486 20.0001 18.6667 20.0001C14.9848 20.0001 12 17.0153 12 13.3334C12 9.65152 14.9848 6.66675 18.6667 6.66675C22.3486 6.66675 25.3333 9.65152 25.3333 13.3334Z" fill="#AAAAAA" />
            <path
                d="M32 29.3335H24M27.9988 33.3334L27.9997 25.3334M8 33.3334V32.0001C8 28.3182 10.9848 25.3334 14.6667 25.3334H18.6667M25.3333 13.3334C25.3333 17.0153 22.3486 20.0001 18.6667 20.0001C14.9848 20.0001 12 17.0153 12 13.3334C12 9.65152 14.9848 6.66675 18.6667 6.66675C22.3486 6.66675 25.3333 9.65152 25.3333 13.3334Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
